import axios from 'axios'

export function postRequest(url,data) {
    return axios.post(url,data,
    { 
        crossdomain: true,
        headers:{
            'Access-Control-Allow-Origin' : '*',
            'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
        }
   })
}
export function putRequest(url,data,bearerToken='') {
	return axios.put(url,data,
	{ 
		crossdomain: true,
		headers: {
			'Access-Control-Allow-Origin' : '*',
			'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
			'Authorization' : `Bearer ${bearerToken}`
		}
	})
}

export function getRequest(url, responseType,bearerToken='') 
{
	//console.log(`getRequest bearerToken ${url}, ${bearerToken}`)
	return axios.get(url,
		{ 
			crossdomain: true,
			headers: {
				'Access-Control-Allow-Origin' : '*',
				'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
				'Authorization' : `Bearer ${bearerToken}`
			},
			responseType: responseType != undefined ? responseType: 'json'
		})
}


// WEBPACK FOOTER //
// ./src/utils/functions/httpRequest.js